import firestoreDB from './firestore'
import firebaseDB from './firebase'
import store from './store'
import {
    userConstants,
    coworkingsConstants,
    singleWorkstationsConstants,
    meetingRoomsConstants,
} from './redux-constants'
import { checkUserAuthDone } from './actions/index.js'

// Array for containing each store listener for sign-out flow
export let documentListeners = []

// Listen for authentication changes.
firebaseDB.auth().onAuthStateChanged(async user => {
    if (user) {
        const userProfileDocument = firestoreDB.doc(`users/${user.uid}`)
        documentListeners.push(
            userProfileDocument.onSnapshot(doc => {
                store.dispatch({
                    type: userConstants.UPDATE_USER,
                    payload: {
                        ...user.providerData[0],
                        emailVerified: user.emailVerified,
                        uid: user.uid,
                        ...doc.data(),
                    },
                })
            })
        )

        const ownerSubCollections = [
            {
                name: 'singleWorkstations',
                constants: singleWorkstationsConstants,
            },
            {
                name: 'meetingRooms',
                constants: meetingRoomsConstants,
            },
        ]

        const userData = await userProfileDocument.get()
        if (userData?.data()?.role === 'owner') {
            const topLevelCollection = firestoreDB.collection('coworkings')
            documentListeners.push(
                topLevelCollection.onSnapshot(
                    result => {
                        let collectionContent = []

                        result.docChanges().forEach(change => {
                            const id = change.doc.id
                            const data = change.doc.data()
                            if (userData?.data()?.ownerOf?.includes(id)) {
                                if (change.type === 'added') {
                                    collectionContent.push({ id, ...data })

                                    ownerSubCollections.forEach(
                                        collectionData => {
                                            const singleSubcoll = firestoreDB
                                                .collection('coworkings')
                                                .doc(id)
                                                .collection(collectionData.name)

                                            singleSubcoll.onSnapshot(
                                                result => {
                                                    let subCollectionDocs = []

                                                    result
                                                        .docChanges()
                                                        .forEach(change => {
                                                            const subData = change.doc.data()

                                                            if (
                                                                change.type ===
                                                                'added'
                                                            ) {
                                                                subCollectionDocs.push(
                                                                    {
                                                                        id:
                                                                            change
                                                                                .doc
                                                                                .id,
                                                                        ...subData,
                                                                    }
                                                                )
                                                            } else if (
                                                                change.type ===
                                                                'modified'
                                                            ) {
                                                                store.dispatch({
                                                                    type:
                                                                        collectionData[
                                                                            'constants'
                                                                        ]
                                                                            .UPDATE,
                                                                    payload: {
                                                                        cowoRef: id,
                                                                        id:
                                                                            change
                                                                                .doc
                                                                                .id,
                                                                        data: subData,
                                                                    },
                                                                })
                                                            } else if (
                                                                change.type ===
                                                                'removed'
                                                            ) {
                                                                //removed
                                                                store.dispatch({
                                                                    type:
                                                                        collectionData[
                                                                            'constants'
                                                                        ]
                                                                            .REMOVE,
                                                                    payload: {
                                                                        cowoRef: id,
                                                                        id:
                                                                            change
                                                                                .doc
                                                                                .id,
                                                                    },
                                                                })
                                                            }
                                                        })

                                                    if (
                                                        subCollectionDocs.length
                                                    ) {
                                                        store.dispatch({
                                                            type:
                                                                collectionData[
                                                                    'constants'
                                                                ].ADD_ITEMS,
                                                            payload: {
                                                                cowoRef: id,
                                                                list: subCollectionDocs,
                                                            },
                                                        })
                                                    }
                                                },
                                                error => {
                                                    console.log('error', error)
                                                    store.dispatch({
                                                        type:
                                                            collectionData[
                                                                'constants'
                                                            ].AJAX_CALL_FAILURE,
                                                        payload: error,
                                                    })
                                                }
                                            )
                                        }
                                    )
                                } else if (change.type === 'modified') {
                                    store.dispatch({
                                        type:
                                            coworkingsConstants.UPDATE_COWORKINGS,
                                        payload: { id, ...data },
                                    })
                                } else if (change.type === 'removed') {
                                    //removed
                                    // store.dispatch({
                                    //     type: `${collectionName}_REMOVE`,
                                    //     payload: { id, ...data },
                                    // })
                                }
                            }
                        })

                        if (collectionContent.length) {
                            store.dispatch({
                                type: coworkingsConstants.ADD_ITEMS,
                                payload: collectionContent,
                            })
                        }
                    },
                    error => {
                        console.log('error', error)
                        store.dispatch({
                            type: coworkingsConstants.AJAX_CALL_FAILURE,
                            payload: error,
                        })
                    }
                )
            )
        }
    } else if (documentListeners.length) {
        // Handle sign out flow
        // Unsubscribe from each store listener
        documentListeners.forEach(listener => listener())
    } else {
        store.dispatch(checkUserAuthDone())
    }
})
